<template>
  <div class="promotion-refer-friend-view default-page">
    <img
      :src="bannerImage"
      alt="Акція 6+1 від Crystal"
      class="default-page__banner mb-5"
    />
    <h1>Акція «Приведи друга»</h1>
    <div class="default-page-section">
      Підключіть друга – отримайте бонуси! <br class="d-block d-md-none" />
      💰 По 3500 бонусів Вам і другу
    </div>
    <div class="default-page-section">
      <ul>
        <li><span>1️⃣</span> Завантажте застосунок My Crystal</li>
        <li>
          <span>2️⃣</span> Запросіть друга через спеціальну форму в застосунку
        </li>
        <li>
          <span>3️⃣</span> Отримайте бонуси на рахунок після повної абонплати
          друга
        </li>
      </ul>
    </div>
    <div class="default-page-section">
      🔥 Використовуйте бонуси для оплати інтернету!
      <br class="d-block d-md-none" />
      Та запрошуйте ще більше друзів 😉
    </div>
    <div class="default-page-section mb-0">
      <router-link :to="{ name: 'mobile-app' }">
        <app-btn class="btn btn-primary w-100">
          Завантажити застосунок
        </app-btn>
      </router-link>
    </div>
  </div>
</template>

<script>
import AppBtn from "@/components/common/ui/AppBtn.vue";
import bannerImage from "@/assets/promotions/banner-stock-3.jpg";

export default {
  name: "PromotionReferFriendView",
  components: {
    AppBtn,
  },
  setup() {
    return {
      bannerImage,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_mixins.less";

.promotion-refer-friend-view {
  .default-page-section {
    .default-ul-list();
  }
}
</style>
